import orderBy from 'lodash/orderBy';

// Actions
const FETCH_ZCC_INSTALLATIONS             = 'zen/zccInstallations/FETCH_ZCC_INSTALLATIONS';
const FETCH_ZCC_INSTALLATIONS_SUCCEEDED   = 'zen/zccInstallations/FETCH_ZCC_INSTALLATIONS_SUCCEEDED';
const FETCH_ZCC_INSTALLATIONS_FAILED      = 'zen/zccInstallations/FETCH_ZCC_INSTALLATIONS_FAILED';
const SET_SORT_ATTRIBUTE                  = 'zen/zccInstallations/SET_SORT_ATTRIBUTE';
const SET_ZCC_NOTIFICATION                = 'zen/zccInstallations/SET_ZCC_NOTIFICATION';
const UNSET_ZCC_NOTIFICATION              = 'zen/zccInstallations/UNSET_ZCC_NOTIFICATION';

export const initialState = {
  zccInstallations: [],
  sortingAttribute: 'account',
  isAscendingSort: true,
  loading: false,
  notification: {
    type: null,
    message: null,
    title: null
  }
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_ZCC_INSTALLATIONS:
      return {...state, loading: true};
    case FETCH_ZCC_INSTALLATIONS_SUCCEEDED:
      return {...state, loading: false, zccInstallations: action.payload.zccInstallations};
    case FETCH_ZCC_INSTALLATIONS_FAILED:
      return {
        ...state,
        loading: false,
        zccInstallations: [],
        notification: {
          title: 'Error',
          message: 'An error occurred while trying to load the current Command Center installations, please try again',
          type: 'error'
        }
      };
    case SET_SORT_ATTRIBUTE: {
      const hasAttributeChanged = action.payload !== state.sortingAttribute;
      const isAscendingSort = hasAttributeChanged ? true : !state.isAscendingSort;
      const direction = isAscendingSort ? 'asc' : 'desc';
      let sortedZccInstallations = orderBy(
        state.zccInstallations,
        [(zcc) => zcc[action.payload] && zcc[action.payload].toLowerCase()],
        [direction]
      );
      // always move undefined last ping zccs to bottom
      if (action.payload === 'lastPing') {
        sortedZccInstallations = [
          ...sortedZccInstallations.filter((zcc) => zcc.lastPing),
          ...sortedZccInstallations.filter((zcc) => !zcc.lastPing),
        ];
      }
      return {
        ...state,
        zccInstallations: sortedZccInstallations,
        sortingAttribute: action.payload,
        isAscendingSort: hasAttributeChanged ? true : !state.isAscendingSort
      };
    }
    case SET_ZCC_NOTIFICATION:
      return {...state, notification: { ...action.payload } };
    case UNSET_ZCC_NOTIFICATION:
      return {...state, notification: { ...initialState.notification } };
    default: return state;
  }
};

// Action Creators
// FETCH BACON
const fetchZccInstallations = () => {
  return { type: FETCH_ZCC_INSTALLATIONS };
};

const fetchZccInstallationsSucceeded = (payload) => {
  return { type: FETCH_ZCC_INSTALLATIONS_SUCCEEDED, payload };
};

const fetchZccInstallationsFailed = (payload) => {
  return { type: FETCH_ZCC_INSTALLATIONS_FAILED, payload };
};

// OTHER

const setSortAttribute = (attr) => {
  return { type: SET_SORT_ATTRIBUTE, payload: attr };
};

const setZccNotification = ({type, title, message}) => {
  return { type: SET_ZCC_NOTIFICATION, payload: { type, title, message } };
};

const unSetZccNotification = () => {
  return { type: UNSET_ZCC_NOTIFICATION };
};

export default reducer;
export {
  // Actions
  FETCH_ZCC_INSTALLATIONS,
  FETCH_ZCC_INSTALLATIONS_SUCCEEDED,
  FETCH_ZCC_INSTALLATIONS_FAILED,
  SET_ZCC_NOTIFICATION,
  SET_SORT_ATTRIBUTE,
  UNSET_ZCC_NOTIFICATION,
  // Action Creators
  fetchZccInstallations,
  fetchZccInstallationsSucceeded,
  fetchZccInstallationsFailed,
  setSortAttribute,
  setZccNotification,
  unSetZccNotification
};
